import { Dialog } from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import isoCountries from "i18n-iso-countries";
import jwt_decode from "jwt-decode";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { getCompanyById } from "../../slices/Company/CompanySlice";
import { ThemeContext } from "../../theme/ThemeContext";
import CustomPhone from "../CustomInputs/CustomPhone";
import CustomTextfield from "../CustomInputs/CustomTextfield";
import Toast from "../ToastContainer/CustomToast";
import CommonUtil from "../Util/CommonUtils";
import CancelButtons from "./CancelButtons";
import SubmitButtons from "./SubmitButtons";

function BulkInvitationEditDialog({ open, onClose, rowData, onSave }) {
  const [firstName, setFirstName] = useState(rowData.firstName);
  const [phone, setPhone] = useState(rowData.phone);
  const [companyName, setCompanyName] = useState(rowData.visitorCompanyName);
  const [emailId, setEmailId] = useState(rowData.emailId);
  const [phoneCountryCode, setPhoneCountryCode] = useState(
    rowData.phoneCountryCode
  );
  const [phoneNumber, setPhonenumber] = useState(rowData.phoneNumber);
  const [phoneInput, setPhoneInput] = useState(
    rowData.phoneNumber
      ? rowData.phoneCountryCode + "-" + rowData.phoneNumber
      : ""
  );
  const companySettings = JSON.parse(localStorage.getItem("companySettings"));
  const [companyNameStatus, setCompanyNameStatus] = useState(
    companySettings.invitationCompanyName
  );
  const [companyNameMandatory, setCompanyNameMandatory] = useState(
    companySettings.checkInvitationCompanyName
  );
  const dispatch = useDispatch();
  const [country, setCountry] = useState("");
  const { t } = useTranslation();
  const { darkMode } = useContext(ThemeContext);
  var decoded_jwtToken = jwt_decode(
    localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN)
  );

  const handlePhoneChange = (value, data, event, formattedValue) => {
    setPhoneInput(value);
    setPhoneCountryCode("+" + data.dialCode);
    setPhonenumber(value.toString().replace(data.dialCode, ""));
    setPhone(phoneCountryCode + "-" + phoneNumber);
  };

  const handleSave = () => {
    if (firstName === "") {
      Toast(t("USERPROFSCREEN007"), "error");
      return;
    }

    if (emailId === "" && phoneNumber === "") {
      Toast(t("ADD043"), "error");
      return;
    }

    if (!CommonUtil.isValidEmail(emailId)) {
      Toast(t("CORRECTEMAIL"), "error");
      return;
    }
    if (companyNameMandatory && companyName === "") {
      Toast(t("DEALERCOMPANYERROR"), "error");
      return;
    }

    onSave({
      ...rowData,
      firstName,
      emailId,
      phoneNumber,
      phoneCountryCode,
      companyName,
      phone,
    });
    Toast(t("ADD044"), "success");
    onClose();
  };

  useEffect(() => {
    if (phoneInput === "" || phoneInput === null) {
      loadCompany();
    }
  }, []);

  const loadCompany = () => {
    dispatch(getCompanyById(decoded_jwtToken.companyId))
      .unwrap()
      .then((data) => {
        if ((data.code = "UASI0026")) {
          const fullCountryName = data.data.country;
          const countryCode = getCountryCodeFromName(fullCountryName);
          if (countryCode) {
            setCountry(countryCode);
          } else {
            setCountry("us");
          }
        }
      })
      .catch((er) => {});
  };
  const getCountryCodeFromName = (countryName) => {
    const formattedCountryName = countryName
      .toLowerCase()
      .replace(/\b\w/g, (l) => l.toUpperCase());
    const countryCode = (
      isoCountries.getAlpha2Code(formattedCountryName, "en") || ""
    ).toLowerCase();
    return countryCode || null;
  };

  return (
    <>
      <Dialog
        open={open}
        fullWidth={true}
        PaperProps={{
          style: {
            borderRadius: "20px !important",
            minWidth: "40vw",
            backgroundColor: darkMode ? "rgb(14, 42, 65)" : "#fff",
            color: darkMode ? "#fff" : "#434547",
          },
        }}
        disableBackdropClick
        disableEscapeKeyDown
        BackdropProps={{
          style: {
            backdropFilter: "blur(5px)",
          },
        }}
      >
        <DialogTitle variant="h4">
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 15,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon onClick={onClose} />
          </IconButton>
          <Typography
            style={{
              color: darkMode ? "#fff" : "black",
              fontSize: "20px",
              fontWeight: "450",
            }}
          >
            {t("ADD042")}
          </Typography>
        </DialogTitle>
        <Divider
          variant="middle"
          style={{
            background: darkMode
              ? "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box"
              : "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box",
            height: "1px",
            opacity: 0.5,
          }}
        />
        <DialogContent style={{ paddingBottom: "0px" }}>
          <Grid
            container
            justifyContent="center"
            rowSpacing={2}
            columnSpacing={1}
          >
            <Grid item xs={12} sm={6}>
              <CustomTextfield
                type="text"
                name="FirstName"
                label={t("COMMON020")}
                value={firstName}
                required={true}
                handleChange={(e) => setFirstName(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomTextfield
                type="text"
                name="Email"
                label={t("COMMON042")}
                value={emailId}
                required={true}
                handleChange={(e) => setEmailId(e.target.value)}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={Number(!companyNameStatus) % 2 === 1 ? 12 : 6}
            >
              <CustomPhone
                placeholder="Mobile"
                value={phoneInput}
                country={country}
                specialLabel={false}
                handleChange={(value, data, event, formattedValue) =>
                  handlePhoneChange(value, data, event, formattedValue)
                }
              />
            </Grid>
            {companyNameStatus && (
              <Grid item xs={12} sm={6}>
                <CustomTextfield
                  type="text"
                  name="CompanyName"
                  label={t("VISUPDATE0006")}
                  required={companyNameMandatory}
                  value={companyName}
                  handleChange={(e) => setCompanyName(e.target.value)}
                  disabled={!!rowData.visitorCompanyName}
                />
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions
          style={{
            justifyContent: "center",
          }}
        >
          <CancelButtons
            variant="contained"
            color="secondary"
            onClick={onClose}
          >
            <Typography variant="body1" style={{ textTransform: "none" }}>
              {t("COMMON008")}
            </Typography>
          </CancelButtons>
          <SubmitButtons variant="contained" onClick={handleSave}>
            <Typography variant="body1" style={{ textTransform: "none" }}>
              {t("COMMON007")}
            </Typography>
          </SubmitButtons>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default BulkInvitationEditDialog;
